<div class="container-map">
  <div #map id="map"></div>
</div>
